//货主定金定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 支付方式
 */
class PaymentMethod extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const PAYMENT_METHOD = new PaymentMethod();

/**
 * 支付状态
 */
class PaymentState extends UltMeta {
    UNPAID = new Meta(1, "待支付");
    CONFIRMING = new Meta(2, "确认中");
    CONFIRMED = new Meta(3, "已确认");
}

export const PAYMENT_STATE = new PaymentState();

//  签好运支付状态
class QhyPaymentStatus extends UltMeta {
    TO_BE_RECONCILIATION = new Meta(1, "待对账");
    WAIT_PAY = new Meta(2, "待支付");
    HAS_RECEIVED = new Meta(3, "已到账");
    PAY_FAIL = new Meta(4, "支付失败");
    APPLY_AUDITING = new Meta(5, "待审核");
    PAYING = new Meta(6, "支付中");
    HAS_INVALID = new Meta(7, "已作废");
    REJECTED = new Meta(8, "已拒绝");
}

export const QHY_PAYMENT_STATUS = new QhyPaymentStatus();

/**
 * 支付类型 定金和运费只有自行支付才有用
 */
class OwnerShippingDepositType extends UltMeta {
    DEPOSIT_ONE = new Meta(1, "定金1", 10);
    DEPOSIT_TWO = new Meta(2, "定金2", 12);
    DEPOSIT_THREE = new Meta(3, "定金3", 14);
    BALANCE_PAYMENT = new Meta(4, "尾款", 30);
    DEPARTURE_FEE = new Meta(5, "启航费", 20);
    DEMURRAGE = new Meta(6, "滞期费", 40);
    DEPOSIT = new Meta(7, "定金", 88);
    FREIGHT = new Meta(8, "运费", 99);
}

export const OWNER_SHIPPING_DEPOSIT_TYPE = new OwnerShippingDepositType();

/**
 * 状态
 */
class OwnerShippingDepositState extends UltMeta {
    TO_BE_RECONCILIATION = new Meta(1, "待对账");
    TO_BE_PAID = new Meta(2, "待支付");
    PAID = new Meta(3, "已支付");
    PAYMENT_FAILED = new Meta(4, "支付失败");
}

export const OWNER_SHIPPING_DEPOSIT_STATE = new OwnerShippingDepositState();
// 签好运-定金确认状态
class CaptainConfirmState extends UltMeta {
    TO_BE_CONFIRM = new Meta(0, "未确认");
    CONFIRMED = new Meta(1, "已确认");
}

export const CAPTAIN_CONFIRM_STATE = new CaptainConfirmState();
